import { Injector } from '@angular/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { MultiLanguageService } from '@app/share/translate';
import { Store } from '@ngrx/store';
import {
  LoadAppSettings,
  LoginActions,
  StoreAppSettings,
} from '@app/core/store';
import { Actions, ofType } from '@ngrx/effects';
import Storage from '@app/core/utils/storage';
import { AppSettingReq, ContinueAsGuest } from '../models';
import { LoginState } from '@core/store/reducers/login.reducer';
import { Router } from '@angular/router';
import { v4 } from 'uuid';

export function appInitializerLanguageFactory(
  translate: MultiLanguageService,
  injector: Injector
) {
  return () =>
    new Promise<any>((resolve: any) => {
      const store = localStorage.getItem('storeId');
      if (!store) {
        localStorage.setItem('storeId', '1');
      }
      const locationInitialized = injector.get(
        LOCATION_INITIALIZED,
        Promise.resolve(null)
      );
      locationInitialized.then(() => {
        const langToSet = translate.currentLanguage();
        translate.use(langToSet, true).subscribe({
          next: () => {
            //console.info(`Successfully initialized '${langToSet}' language.'`);
          },
          error: () => {
            console.error(
              `Problem with '${langToSet}' language initialization.'`
            );
          },
          complete: () => {
            resolve(null);
          },
        });
      });
    });
}

export function appInitializerContinueAsGuestFactory(
  router: Router,
  store: Store,
  _actions$: Actions,
  injector: Injector
) {
  return () =>
    new Promise<any>((resolve: any, reject: any) => {
      _actions$.pipe(ofType(LoginActions.loginSuccess)).subscribe({
        next: (data: any) => {
          resolve(null);
        },
      });
      Storage.set('newAppLoad', true);
      _actions$.pipe(ofType(LoginActions.loginError)).subscribe({
        next: (data) => {
          reject(null);
        },
      });
      const authStatus: { login: LoginState } = Storage.get('core');
      if (
        authStatus.login?.authorization.Customer?.Token &&
        authStatus.login.authorization.type === 5
      ) {
        resolve(null);
      } else if (
        authStatus.login.authorization.Customer?.Token &&
        !authStatus.login.authorization.status &&
        authStatus.login.authorization.type !== 5
      ) {
        resolve(null);
        router.navigate(['/login']).then();
      } else if (
        authStatus.login.authorization.Customer?.Token &&
        authStatus.login.authorization.status &&
        authStatus.login.authorization.type !== 5
      ) {
        resolve(null);
      } else {
        const body: ContinueAsGuest = new ContinueAsGuest();
        body.DeviceId = v4();
        localStorage.setItem('uId', body.DeviceId);
        store.dispatch(LoginActions.loginGuest({ payload: body }));
      }
    });
}
export function appInitializerAppSettingsFactory(
  store: Store,
  _actions$: Actions,
  injector: Injector
) {
  return () =>
    new Promise<any>((resolve: any, reject: any) => {
      _actions$.pipe(ofType(StoreAppSettings)).subscribe({
        next: (data: any) => {
          resolve(null);
        },
      });
      store.dispatch(LoadAppSettings({ payload: new AppSettingReq() }));
    });
}
